import { render } from "./InviteUserAction.vue?vue&type=template&id=c2c4e904&scoped=true"
import script from "./InviteUserAction.vue?vue&type=script&lang=js"
export * from "./InviteUserAction.vue?vue&type=script&lang=js"

import "./InviteUserAction.vue?vue&type=style&index=0&id=c2c4e904&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2c4e904"]])

export default __exports__